import { render, staticRenderFns } from "./Empower‌ment.vue?vue&type=template&id=202dc732&scoped=true&"
import script from "./Empower‌ment.vue?vue&type=script&lang=js&"
export * from "./Empower‌ment.vue?vue&type=script&lang=js&"
import style0 from "./Empower‌ment.vue?vue&type=style&index=0&id=202dc732&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202dc732",
  null
  
)

export default component.exports